export default __webpack_public_path__ + "static/media/5.f0c6ec5f.png";